import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Loader } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants/routes';
import { getConfirmTokenCall, postAcceptInvitationCall } from '@/invitation/state';
import { ErrorFeedback, SuccessFeedback, TokenExpiredFeedback } from '../components';

export const ConfirmEmailScreen: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const {
    loading: loadingGetConfirmToken,
    error: errorGetConfirmToken,
    success: successGetConfirmToken,
    isTokenExpired,
    execute: executeGetConfirmToken,
  } = getConfirmTokenCall.hook();

  const {
    loading: loadingPostAcceptInvitation,
    success: successPostAcceptInvitation,
    error: errorPostAcceptInvitation,
    execute: executePostAcceptInvitation,
  } = postAcceptInvitationCall.hook();

  useEffect(() => {
    if (!token) {
      navigate(Routes.Login, { replace: true });
    } else if (!successGetConfirmToken && !errorGetConfirmToken && !loadingGetConfirmToken) {
      executeGetConfirmToken({
        token,
        successSaga: () => {
          executePostAcceptInvitation({ token });
        },
      });
    }
  }, [
    errorGetConfirmToken,
    executeGetConfirmToken,
    executePostAcceptInvitation,
    loadingGetConfirmToken,
    navigate,
    successGetConfirmToken,
    token,
  ]);

  if (loadingGetConfirmToken || loadingPostAcceptInvitation) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh'>
        <Loader size='xl' />
      </Box>
    );
  }

  if (successPostAcceptInvitation) {
    return <SuccessFeedback namespace='invitation.confirmEmail.success' />;
  }

  if (errorPostAcceptInvitation) {
    return <ErrorFeedback namespace='invitation.confirmEmail.error' />;
  }

  if (errorGetConfirmToken) {
    if (isTokenExpired) {
      return <TokenExpiredFeedback namespace='invitation.confirmEmail.tokenExpired' />;
    }
    return <ErrorFeedback namespace='invitation.confirmEmail.error' />;
  }

  return null;
};
